import { IAutoPlayState } from '@GFTypes/GameStoreTypes/SpinParameters';

export const AUTOPLAY_STATE_DEFAULTS: IAutoPlayState = {
    isEnabled: false,
    currentCount: 0,
    totalCount: 0,
    lossLimit: 0,
    delayBeforeSpin: 0,

    // ADVANCED AUTOPLAY SETTINGS
    stopOnAnyWin: false,
    stopOnBigWin: false,
    stopOnFreeGameStart: false,
    stopOnFreeGameEnd: false,
    stopOnSingleWinExeeds: 0,
    isSuspended: false
};
